import '../../../../../models/customer/visual_mode/filters/date_filter.js.coffee'
import '../../../../../models/customer/visual_mode/filters/status_filter.js.coffee'
import '../../../../../models/customer/visual_mode/filters/users_group_filter.js.coffee'
import '../../../../../models/customer/visual_mode/filters/subtype_filter.js.coffee'
import '../../../../../models/customer/visual_mode/filters/ticket_attributes_filter.coffee'
Namespace 'Common.Dashboard.Filters'

class Common.Dashboard.Filters.UnappliedFiltersView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/filters/unapplied/unapplied_filters']
  className: 'unapplied-filters'

  initialize: ({session, filtersFactory}) ->
    @session = session
    @filtersFactory = filtersFactory
    @filterViews = []

  render: ->
    @$el.empty().append @template()
    $list = @$('.unapplied-filters-list')
    $list.append(filterView.render().el) for filterView in @_filterViews()
    @

  _filterViews: =>
    filterView.remove() for filterView in @filterViews
    @filterViews = (@_addFilterView(filter) for filter in @_filtersToRender())

  _filtersToRender: ->
    appliedFilters = @session.getCompositeFilter().getFilters()
    filterTypes = _.difference(
      @filtersFactory.getFilterTypes(),
      @_excludedTypes()
    )
    filterTypes.map (type) =>
      appliedFilter = appliedFilters.find((filter) -> filter.getFilterType() == type)
      appliedFilter || @filtersFactory.getFilter(type)

  _excludedTypes: ->
    nonReappliableAppliedFilters = @session.getCompositeFilter().nonReappliableFilters()
    _.difference(
      filter.getFilterType() for filter in nonReappliableAppliedFilters,
      [CustomerVisualMode.Filters.TicketAttributesFilter.FILTER_TYPE]
    )

  _addFilterView: (filter) ->
    unappliedFilterView = @_getUnappliedFilterView(filter)
    @listenTo(unappliedFilterView, 'filters:apply', (filter) => @trigger('filters:apply', filter))
    unappliedFilterView

  _getUnappliedFilterView: (filter) ->
    @filtersFactory.getUnappliedView(filter)

  _filterForView: (filter) ->
    if filter.isRemovable() then filter else @_copyWithValues(filter)

  _copyWithValues: (filter) ->
    values = @_valuesForType(filter.getFilterType())
    @filtersFactory.getFilter(filter.getFilterType(), values)

  _valuesForType: (filterType) ->
    @session.getCompositeFilter().filterWithType(filterType).getValues()
